/**
 * Created by karthikeyan.k on 15-11-2017.
 */
export class TutorialPortraitPosition {
  public static get QUICKKEYSHEADERPOSITION(): any {
    return {
      ar: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 454,
        headerTop: 43,

        wordwrap: 'normal',
        lineHeight: 7,
        letterspacing: 0,
        textResize: 8,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 181,
        left3Left: 556,

        left4Width: 16,
        left4Height: 18,
        left4Top: 208,
        left4Left: 556,

        left5Width: 16,
        left5Height: 18,
        left5Top: 232,
        left5Left: 556,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 556,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 556,

        left8Width: 16,
        left8Height: 18,
        left8Top: 311,
        left8Left: 556,

        left9Width: 16,
        left9Height: 18,
        left9Top: 337,
        left9Left: 556,

        left10Width: 16,
        left10Height: 18,
        left10Top: 362,
        left10Left: 556,

        left11Width: 16,
        left11Height: 18,
        left11Top: 387,
        left11Left: 556,

        left12Width: 16,
        left12Height: 18,
        left12Top: 411,
        left12Left: 556,

        left13Width: 16,
        left13Height: 18,
        left13Top: 437,
        left13Left: 556,

        left14Width: 16,
        left14Height: 18,
        left14Top: 461,
        left14Left: 556,

        right1Width: 16,
        right1Height: 18,
        right1Top: 127,
        right1Left: 251,

        right2Width: 16,
        right2Height: 18,
        right2Top: 152,
        right2Left: 251,

        right3Width: 16,
        right3Height: 18,
        right3Top: 179,
        right3Left: 251,

        right4Width: 12,
        right4Height: 18,
        right4Top: 204,
        right4Left: 252,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 252,

        right6Width: 16,
        right6Height: 18,
        right6Top: 255,
        right6Left: 251,

        right7Width: 16,
        right7Height: 18,
        right7Top: 280,
        right7Left: 252,

        right8Width: 25,
        right8Height: 18,
        right8Top: 307,
        right8Left: 247,

        right9Width: 31,
        right9Height: 18,
        right9Top: 336,
        right9Left: 244,

        right10Width: 31,
        right10Height: 18,
        right10Top: 361,
        right10Left: 244,

        right11Width: 31,
        right11Height: 18,
        right11Top: 387,
        right11Left: 244,

        right12Width: 31,
        right12Height: 18,
        right12Top: 413,
        right12Left: 244,

        right13Width: 16,
        right13Height: 18,
        right13Top: 438,
        right13Left: 252,

        right14Width: 16,
        right14Height: 18,
        right14Top: 464,
        right14Left: 250,
      },
      hy: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 154,
        headerTop: 44,

        wordwrap: 'break-word',
        lineHeight: 7,
        letterspacing: -0.2,
        textResize: 8,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 87,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 87,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 87,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 87,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 87,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 87,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 87,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 87,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 87,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 87,

        left13Width: 16,
        left13Height: 18,
        left13Top: 437,
        left13Left: 87,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 87,

        right1Width: 16,
        right1Height: 18,
        right1Top: 130,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 403,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 403,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 403,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 403,

        right8Width: 32,
        right8Height: 18,
        right8Top: 307,
        right8Left: 394,

        right9Width: 30,
        right9Height: 18,
        right9Top: 335,
        right9Left: 396,

        right10Width: 30,
        right10Height: 18,
        right10Top: 361,
        right10Left: 396,

        right11Width: 30,
        right11Height: 18,
        right11Top: 387,
        right11Left: 396,

        right12Width: 30,
        right12Height: 18,
        right12Top: 413,
        right12Left: 396,

        right13Width: 16,
        right13Height: 18,
        right13Top: 438,
        right13Left: 402,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 402,
      },
      bg: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 154,
        headerTop: 48,

        wordwrap: 'break-word',
        lineHeight: 7,
        letterspacing: -0.05,
        textResize: 9,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 88,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 88,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 88,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 88,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 88,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 88,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 88,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 88,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 88,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 88,

        left13Width: 16,
        left13Height: 18,
        left13Top: 437,
        left13Left: 88,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 88,

        right1Width: 16,
        right1Height: 18,
        right1Top: 130,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 403,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 403,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 403,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 403,

        right8Width: 33,
        right8Height: 18,
        right8Top: 306,
        right8Left: 394,

        right9Width: 34,
        right9Height: 18,
        right9Top: 336,
        right9Left: 394,

        right10Width: 34,
        right10Height: 18,
        right10Top: 362,
        right10Left: 394,

        right11Width: 34,
        right11Height: 18,
        right11Top: 389,
        right11Left: 394,

        right12Width: 34,
        right12Height: 18,
        right12Top: 415,
        right12Left: 394,

        right13Width: 16,
        right13Height: 18,
        right13Top: 438,
        right13Left: 403,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 403,
      },
      kh: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 236,
        headerTop: 45,

        wordwrap: 'normal',
        lineHeight: 7,
        letterspacing: -0.2,
        textResize: 8,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 88,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 87,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 87,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 87,

        left7Width: 16,
        left7Height: 18,
        left7Top: 284,
        left7Left: 87,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 87,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 87,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 87,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 87,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 87,

        left13Width: 16,
        left13Height: 18,
        left13Top: 438,
        left13Left: 87,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 87,

        right1Width: 16,
        right1Height: 18,
        right1Top: 130,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 403,

        right4Width: 18,
        right4Height: 18,
        right4Top: 206,
        right4Left: 403,

        right5Width: 17,
        right5Height: 18,
        right5Top: 231,
        right5Left: 403,

        right6Width: 17,
        right6Height: 18,
        right6Top: 257,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 403,

        right8Width: 34,
        right8Height: 18,
        right8Top: 307,
        right8Left: 394,

        right9Width: 34,
        right9Height: 18,
        right9Top: 336,
        right9Left: 395,

        right10Width: 34,
        right10Height: 18,
        right10Top: 361,
        right10Left: 395,

        right11Width: 34,
        right11Height: 18,
        right11Top: 388,
        right11Left: 395,

        right12Width: 34,
        right12Height: 18,
        right12Top: 414,
        right12Left: 395,

        right13Width: 16,
        right13Height: 18,
        right13Top: 439,
        right13Left: 403,

        right14Width: 16,
        right14Height: 18,
        right14Top: 464,
        right14Left: 403,
      },
      'zh-Hans': {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 236,
        headerTop: 45,

        wordwrap: 'break-word',
        lineHeight: 7,
        letterspacing: -0.2,
        textResize: 9,
        symbolResize: 13,
        right4SymbolResize: 13,
        right7SymbolResize: 13,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 117,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 117,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 117,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 117,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 117,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 117,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 117,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 117,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 117,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 117,

        left13Width: 16,
        left13Height: 18,
        left13Top: 437,
        left13Left: 117,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 117,

        right1Width: 16,
        right1Height: 18,
        right1Top: 131,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 156,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 181,
        right3Left: 403,

        right4Width: 16,
        right4Height: 18,
        right4Top: 207,
        right4Left: 403,

        right5Width: 16,
        right5Height: 18,
        right5Top: 232,
        right5Left: 403,

        right6Width: 16,
        right6Height: 18,
        right6Top: 258,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 403,

        right8Width: 32,
        right8Height: 18,
        right8Top: 308,
        right8Left: 394,

        right9Width: 34,
        right9Height: 18,
        right9Top: 341,
        right9Left: 394,

        right10Width: 34,
        right10Height: 18,
        right10Top: 365,
        right10Left: 394,

        right11Width: 34,
        right11Height: 18,
        right11Top: 392,
        right11Left: 394,

        right12Width: 34,
        right12Height: 18,
        right12Top: 418,
        right12Left: 394,

        right13Width: 16,
        right13Height: 18,
        right13Top: 439,
        right13Left: 403,

        right14Width: 16,
        right14Height: 18,
        right14Top: 463,
        right14Left: 403,
      },
      'zh-Hant': {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 236,
        headerTop: 45,

        wordwrap: 'break-word',
        lineHeight: 7,
        letterspacing: -0.2,
        textResize: 9,
        symbolResize: 13,
        right4SymbolResize: 13,
        right7SymbolResize: 13,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 117,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 117,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 117,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 117,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 117,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 117,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 117,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 117,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 117,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 117,

        left13Width: 16,
        left13Height: 18,
        left13Top: 437,
        left13Left: 117,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 117,

        right1Width: 16,
        right1Height: 18,
        right1Top: 129,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 156,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 181,
        right3Left: 403,

        right4Width: 16,
        right4Height: 18,
        right4Top: 207,
        right4Left: 403,

        right5Width: 16,
        right5Height: 18,
        right5Top: 233,
        right5Left: 403,

        right6Width: 16,
        right6Height: 18,
        right6Top: 258,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 403,

        right8Width: 32,
        right8Height: 18,
        right8Top: 308,
        right8Left: 394,

        right9Width: 34,
        right9Height: 18,
        right9Top: 340,
        right9Left: 394,

        right10Width: 34,
        right10Height: 18,
        right10Top: 365,
        right10Left: 394,

        right11Width: 34,
        right11Height: 18,
        right11Top: 392,
        right11Left: 394,

        right12Width: 34,
        right12Height: 18,
        right12Top: 418,
        right12Left: 394,

        right13Width: 16,
        right13Height: 18,
        right13Top: 440,
        right13Left: 404,

        right14Width: 16,
        right14Height: 18,
        right14Top: 464,
        right14Left: 404,
      },
      cs: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 149,
        headerTop: 45,

        wordwrap: 'break-word',
        lineHeight: 7,
        letterspacing: -0.2,
        textResize: 9,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 179,
        left3Left: 88,

        left4Width: 16,
        left4Height: 12,
        left4Top: 207,
        left4Left: 88,

        left5Width: 16,
        left5Height: 16,
        left5Top: 233,
        left5Left: 88,

        left6Width: 16,
        left6Height: 16,
        left6Top: 259,
        left6Left: 88,

        left7Width: 16,
        left7Height: 16,
        left7Top: 284,
        left7Left: 88,

        left8Width: 16,
        left8Height: 16,
        left8Top: 311,
        left8Left: 88,

        left9Width: 16,
        left9Height: 16,
        left9Top: 337,
        left9Left: 88,

        left10Width: 16,
        left10Height: 16,
        left10Top: 362,
        left10Left: 88,

        left11Width: 16,
        left11Height: 16,
        left11Top: 388,
        left11Left: 88,

        left12Width: 16,
        left12Height: 14,
        left12Top: 413,
        left12Left: 88,

        left13Width: 16,
        left13Height: 18,
        left13Top: 437,
        left13Left: 88,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 88,

        right1Width: 16,
        right1Height: 16,
        right1Top: 128,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 403,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 403,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 403,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 403,

        right8Width: 32,
        right8Height: 18,
        right8Top: 307,
        right8Left: 394,

        right9Width: 32,
        right9Height: 18,
        right9Top: 337,
        right9Left: 394,

        right10Width: 32,
        right10Height: 18,
        right10Top: 362,
        right10Left: 394,

        right11Width: 32,
        right11Height: 18,
        right11Top: 389,
        right11Left: 394,

        right12Width: 32,
        right12Height: 18,
        right12Top: 415,
        right12Left: 394,

        right13Width: 16,
        right13Height: 18,
        right13Top: 437,
        right13Left: 403,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 402,
      },
      da: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 155,
        headerTop: 41,

        wordwrap: 'break-word',
        lineHeight: 7,
        letterspacing: -0.08,
        textResize: 10,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 89,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 89,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 89,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 89,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 89,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 89,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 89,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 89,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 89,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 89,

        left13Width: 16,
        left13Height: 18,
        left13Top: 437,
        left13Left: 89,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 89,

        right1Width: 16,
        right1Height: 18,
        right1Top: 130,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 403,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 403,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 403,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 403,

        right8Width: 31,
        right8Height: 18,
        right8Top: 307,
        right8Left: 395,

        right9Width: 32,
        right9Height: 18,
        right9Top: 335,
        right9Left: 394,

        right10Width: 32,
        right10Height: 18,
        right10Top: 360,
        right10Left: 394,

        right11Width: 32,
        right11Height: 18,
        right11Top: 386,
        right11Left: 394,

        right12Width: 32,
        right12Height: 18,
        right12Top: 413,
        right12Left: 394,

        right13Width: 16,
        right13Height: 18,
        right13Top: 438,
        right13Left: 402,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 402,
      },
      nl: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 174,
        headerTop: 45,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.09,
        textResize: 8,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 178,
        left3Left: 89,

        left4Width: 16,
        left4Height: 18,
        left4Top: 204,
        left4Left: 89,

        left5Width: 16,
        left5Height: 18,
        left5Top: 230,
        left5Left: 89,

        left6Width: 16,
        left6Height: 18,
        left6Top: 255,
        left6Left: 89,

        left7Width: 16,
        left7Height: 18,
        left7Top: 281,
        left7Left: 89,

        left8Width: 16,
        left8Height: 18,
        left8Top: 309,
        left8Left: 89,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 89,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 89,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 89,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 89,

        left13Width: 16,
        left13Height: 18,
        left13Top: 438,
        left13Left: 89,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 89,

        right1Width: 16,
        right1Height: 18,
        right1Top: 129,
        right1Left: 402,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 402,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 402,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 402,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 402,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 402,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 402,

        right8Width: 25,
        right8Height: 18,
        right8Top: 307,
        right8Left: 398,

        right9Width: 31,
        right9Height: 18,
        right9Top: 341,
        right9Left: 395,

        right10Width: 31,
        right10Height: 18,
        right10Top: 366,
        right10Left: 395,

        right11Width: 31,
        right11Height: 18,
        right11Top: 391,
        right11Left: 395,

        right12Width: 31,
        right12Height: 18,
        right12Top: 418,
        right12Left: 395,

        right13Width: 16,
        right13Height: 18,
        right13Top: 438,
        right13Left: 402,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 402,
      },
      en: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 172,
        headerTop: 45,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.09,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 89,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 89,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 89,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 89,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 89,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 89,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 89,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 89,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 89,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 89,

        left13Width: 16,
        left13Height: 18,
        left13Top: 438,
        left13Left: 89,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 89,

        right1Width: 16,
        right1Height: 18,
        right1Top: 130,
        right1Left: 402,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 402,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 402,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 402,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 402,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 401,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 402,

        right8Width: 25,
        right8Height: 18,
        right8Top: 307,
        right8Left: 398,

        right9Width: 31,
        right9Height: 18,
        right9Top: 342,
        right9Left: 395,

        right10Width: 31,
        right10Height: 18,
        right10Top: 367,
        right10Left: 395,

        right11Width: 31,
        right11Height: 18,
        right11Top: 392,
        right11Left: 395,

        right12Width: 31,
        right12Height: 18,
        right12Top: 420,
        right12Left: 395,

        right13Width: 16,
        right13Height: 18,
        right13Top: 438,
        right13Left: 402,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 402,
      },
      ee: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 172,
        headerTop: 45,

        wordwrap: 'normal',
        lineHeight: 10,
        letterspacing: -0.09,
        textResize: 10,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 88,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 88,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 88,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 88,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 88,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 88,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 88,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 88,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 88,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 88,

        left13Width: 16,
        left13Height: 18,
        left13Top: 438,
        left13Left: 88,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 88,

        right1Width: 16,
        right1Height: 18,
        right1Top: 130,
        right1Left: 418,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 418,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 418,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 418,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 418,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 418,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 418,

        right8Width: 25,
        right8Height: 18,
        right8Top: 307,
        right8Left: 414,

        right9Width: 31,
        right9Height: 18,
        right9Top: 339,
        right9Left: 411,

        right10Width: 31,
        right10Height: 18,
        right10Top: 364,
        right10Left: 411,

        right11Width: 31,
        right11Height: 18,
        right11Top: 391,
        right11Left: 411,

        right12Width: 31,
        right12Height: 18,
        right12Top: 418,
        right12Left: 411,

        right13Width: 16,
        right13Height: 18,
        right13Top: 437,
        right13Left: 418,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 418,
      },
      ph: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 161,
        headerTop: 45,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.09,
        textResize: 8,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 89,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 89,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 89,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 89,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 89,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 89,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 89,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 89,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 89,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 89,

        left13Width: 16,
        left13Height: 18,
        left13Top: 438,
        left13Left: 89,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 89,

        right1Width: 16,
        right1Height: 18,
        right1Top: 130,
        right1Left: 402,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 402,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 402,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 402,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 403,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 402,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 402,

        right8Width: 25,
        right8Height: 18,
        right8Top: 307,
        right8Left: 398,

        right9Width: 31,
        right9Height: 18,
        right9Top: 342,
        right9Left: 395,

        right10Width: 31,
        right10Height: 18,
        right10Top: 368,
        right10Left: 395,

        right11Width: 31,
        right11Height: 18,
        right11Top: 394,
        right11Left: 395,

        right12Width: 31,
        right12Height: 18,
        right12Top: 420,
        right12Left: 395,

        right13Width: 16,
        right13Height: 18,
        right13Top: 437,
        right13Left: 402,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 402,
      },
      fi: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 153,
        headerTop: 45,

        wordwrap: 'break-word',
        lineHeight: 8,
        letterspacing: 0,
        textResize: 9,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 89,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 89,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 89,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 89,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 89,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 89,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 89,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 89,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 89,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 89,

        left13Width: 16,
        left13Height: 18,
        left13Top: 437,
        left13Left: 89,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 89,

        right1Width: 16,
        right1Height: 18,
        right1Top: 130,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 403,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 403,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 403,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 403,

        right8Width: 32,
        right8Height: 18,
        right8Top: 307,
        right8Left: 394,

        right9Width: 34,
        right9Height: 18,
        right9Top: 336,
        right9Left: 394,

        right10Width: 34,
        right10Height: 18,
        right10Top: 361,
        right10Left: 394,

        right11Width: 34,
        right11Height: 18,
        right11Top: 387,
        right11Left: 394,

        right12Width: 34,
        right12Height: 18,
        right12Top: 413,
        right12Left: 394,

        right13Width: 16,
        right13Height: 18,
        right13Top: 438,
        right13Left: 402,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 402,
      },
      fr: {
        headerWidth: 25,
        headerHeight: 32,
        headerLeft: 153,
        headerTop: 46,

        wordwrap: 'break-word',
        lineHeight: 7,
        letterspacing: -1,
        textResize: 9,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 89,

        left4Width: 16,
        left4Height: 18,
        left4Top: 207,
        left4Left: 89,

        left5Width: 16,
        left5Height: 18,
        left5Top: 236,
        left5Left: 89,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 89,

        left7Width: 16,
        left7Height: 18,
        left7Top: 282,
        left7Left: 89,

        left8Width: 16,
        left8Height: 18,
        left8Top: 311,
        left8Left: 89,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 89,

        left10Width: 16,
        left10Height: 18,
        left10Top: 359,
        left10Left: 89,

        left11Width: 16,
        left11Height: 18,
        left11Top: 388,
        left11Left: 89,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 89,

        left13Width: 16,
        left13Height: 18,
        left13Top: 437,
        left13Left: 89,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 89,

        right1Width: 16,
        right1Height: 18,
        right1Top: 130,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 403,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 403,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 403,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 403,

        right8Width: 32,
        right8Height: 18,
        right8Top: 307,
        right8Left: 394,

        right9Width: 30,
        right9Height: 18,
        right9Top: 338,
        right9Left: 394,

        right10Width: 30,
        right10Height: 18,
        right10Top: 363,
        right10Left: 394,

        right11Width: 30,
        right11Height: 18,
        right11Top: 389,
        right11Left: 394,

        right12Width: 30,
        right12Height: 18,
        right12Top: 417,
        right12Left: 394,

        right13Width: 16,
        right13Height: 18,
        right13Top: 438,
        right13Left: 402,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 403,
      },
      ge: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 155,
        headerTop: 45,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.09,
        textResize: 9,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 88,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 88,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 88,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 88,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 88,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 88,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 88,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 88,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 88,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 88,

        left13Width: 16,
        left13Height: 18,
        left13Top: 438,
        left13Left: 88,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 88,

        right1Width: 16,
        right1Height: 18,
        right1Top: 130,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 151,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 176,
        right3Left: 403,

        right4Width: 16,
        right4Height: 18,
        right4Top: 202,
        right4Left: 403,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 403,

        right6Width: 16,
        right6Height: 18,
        right6Top: 255,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 282,
        right7Left: 403,

        right8Width: 25,
        right8Height: 18,
        right8Top: 307,
        right8Left: 398,

        right9Width: 31,
        right9Height: 18,
        right9Top: 343,
        right9Left: 395,

        right10Width: 31,
        right10Height: 18,
        right10Top: 368,
        right10Left: 395,

        right11Width: 31,
        right11Height: 18,
        right11Top: 394,
        right11Left: 395,

        right12Width: 31,
        right12Height: 18,
        right12Top: 420,
        right12Left: 395,

        right13Width: 16,
        right13Height: 18,
        right13Top: 435,
        right13Left: 403,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 403,
      },
      de: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 172,
        headerTop: 45,

        wordwrap: 'break-word',
        lineHeight: 8,
        letterspacing: -0.2,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 89,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 89,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 89,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 89,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 89,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 89,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 89,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 89,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 89,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 89,

        left13Width: 16,
        left13Height: 18,
        left13Top: 437,
        left13Left: 89,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 89,

        right1Width: 16,
        right1Height: 18,
        right1Top: 130,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 403,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 403,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 403,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 403,

        right8Width: 32,
        right8Height: 18,
        right8Top: 307,
        right8Left: 394,

        right9Width: 28,
        right9Height: 18,
        right9Top: 334,
        right9Left: 396,

        right10Width: 28,
        right10Height: 18,
        right10Top: 359,
        right10Left: 396,

        right11Width: 28,
        right11Height: 18,
        right11Top: 385,
        right11Left: 396,

        right12Width: 28,
        right12Height: 18,
        right12Top: 413,
        right12Left: 396,

        right13Width: 16,
        right13Height: 18,
        right13Top: 438,
        right13Left: 402,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 402,
      },
      gr: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 154,
        headerTop: 46,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.09,
        textResize: 10,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 88,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 88,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 88,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 88,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 88,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 88,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 88,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 88,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 88,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 88,

        left13Width: 16,
        left13Height: 18,
        left13Top: 438,
        left13Left: 88,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 88,

        right1Width: 16,
        right1Height: 18,
        right1Top: 130,
        right1Left: 402,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 402,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 402,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 402,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 402,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 401,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 402,

        right8Width: 25,
        right8Height: 18,
        right8Top: 307,
        right8Left: 398,

        right9Width: 31,
        right9Height: 18,
        right9Top: 343,
        right9Left: 395,

        right10Width: 31,
        right10Height: 18,
        right10Top: 368,
        right10Left: 395,

        right11Width: 31,
        right11Height: 18,
        right11Top: 394,
        right11Left: 395,

        right12Width: 31,
        right12Height: 18,
        right12Top: 421,
        right12Left: 395,

        right13Width: 16,
        right13Height: 18,
        right13Top: 438,
        right13Left: 403,

        right14Width: 16,
        right14Height: 18,
        right14Top: 464,
        right14Left: 403,
      },
      he: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 458,
        headerTop: 45,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.09,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 547,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 548,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 548,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 548,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 548,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 548,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 548,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 548,

        left11Width: 16,
        left11Height: 18,
        left11Top: 386,
        left11Left: 548,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 548,

        left13Width: 16,
        left13Height: 18,
        left13Top: 436,
        left13Left: 548,

        left14Width: 16,
        left14Height: 18,
        left14Top: 461,
        left14Left: 548,

        right1Width: 16,
        right1Height: 18,
        right1Top: 129,
        right1Left: 242,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 242,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 242,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 242,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 242,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 242,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 242,

        right8Width: 25,
        right8Height: 18,
        right8Top: 307,
        right8Left: 238,

        right9Width: 31,
        right9Height: 18,
        right9Top: 342,
        right9Left: 235,

        right10Width: 31,
        right10Height: 18,
        right10Top: 368,
        right10Left: 235,

        right11Width: 31,
        right11Height: 18,
        right11Top: 393,
        right11Left: 235,

        right12Width: 31,
        right12Height: 18,
        right12Top: 420,
        right12Left: 235,

        right13Width: 16,
        right13Height: 18,
        right13Top: 438,
        right13Left: 242,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 242,
      },
      'hi-IN': {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 197,
        headerTop: 45,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.09,
        textResize: 12,
        symbolResize: 13,
        right4SymbolResize: 13,
        right7SymbolResize: 13,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 93,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 93,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 93,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 93,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 93,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 93,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 93,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 93,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 93,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 93,

        left13Width: 16,
        left13Height: 18,
        left13Top: 438,
        left13Left: 93,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 93,

        right1Width: 16,
        right1Height: 18,
        right1Top: 131,
        right1Left: 397,

        right2Width: 16,
        right2Height: 18,
        right2Top: 156,
        right2Left: 397,

        right3Width: 16,
        right3Height: 18,
        right3Top: 181,
        right3Left: 397,

        right4Width: 16,
        right4Height: 18,
        right4Top: 207,
        right4Left: 397,

        right5Width: 16,
        right5Height: 18,
        right5Top: 232,
        right5Left: 397,

        right6Width: 16,
        right6Height: 18,
        right6Top: 258,
        right6Left: 397,

        right7Width: 16,
        right7Height: 18,
        right7Top: 284,
        right7Left: 397,

        right8Width: 25,
        right8Height: 18,
        right8Top: 308,
        right8Left: 393,

        right9Width: 31,
        right9Height: 18,
        right9Top: 345,
        right9Left: 390,

        right10Width: 31,
        right10Height: 18,
        right10Top: 370,
        right10Left: 390,

        right11Width: 31,
        right11Height: 18,
        right11Top: 395,
        right11Left: 390,

        right12Width: 31,
        right12Height: 18,
        right12Top: 422,
        right12Left: 390,

        right13Width: 16,
        right13Height: 18,
        right13Top: 439,
        right13Left: 397,

        right14Width: 16,
        right14Height: 18,
        right14Top: 463,
        right14Left: 397,
      },
      hu: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 158,
        headerTop: 45,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.09,
        textResize: 8,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 89,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 89,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 89,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 89,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 89,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 89,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 89,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 89,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 89,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 89,

        left13Width: 16,
        left13Height: 18,
        left13Top: 438,
        left13Left: 89,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 89,

        right1Width: 16,
        right1Height: 18,
        right1Top: 130,
        right1Left: 402,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 402,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 402,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 402,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 402,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 401,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 402,

        right8Width: 25,
        right8Height: 18,
        right8Top: 307,
        right8Left: 398,

        right9Width: 31,
        right9Height: 18,
        right9Top: 343,
        right9Left: 395,

        right10Width: 31,
        right10Height: 18,
        right10Top: 368,
        right10Left: 395,

        right11Width: 31,
        right11Height: 18,
        right11Top: 394,
        right11Left: 395,

        right12Width: 31,
        right12Height: 18,
        right12Top: 421,
        right12Left: 395,

        right13Width: 16,
        right13Height: 18,
        right13Top: 438,
        right13Left: 402,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 402,
      },
      id: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 200,
        headerTop: 45,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.09,
        textResize: 8,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 89,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 89,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 89,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 89,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 89,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 89,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 89,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 89,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 89,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 89,

        left13Width: 16,
        left13Height: 18,
        left13Top: 438,
        left13Left: 89,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 89,

        right1Width: 16,
        right1Height: 18,
        right1Top: 130,
        right1Left: 402,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 402,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 402,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 402,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 402,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 401,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 402,

        right8Width: 25,
        right8Height: 18,
        right8Top: 307,
        right8Left: 398,

        right9Width: 31,
        right9Height: 18,
        right9Top: 342,
        right9Left: 395,

        right10Width: 31,
        right10Height: 18,
        right10Top: 366,
        right10Left: 395,

        right11Width: 31,
        right11Height: 18,
        right11Top: 393,
        right11Left: 395,

        right12Width: 31,
        right12Height: 18,
        right12Top: 420,
        right12Left: 395,

        right13Width: 16,
        right13Height: 18,
        right13Top: 438,
        right13Left: 402,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 402,
      },
      it: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 151,
        headerTop: 45,

        wordwrap: 'break-word',
        lineHeight: 7,
        letterspacing: -0.2,
        textResize: 8,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 179,
        left3Left: 89,

        left4Width: 16,
        left4Height: 18,
        left4Top: 204,
        left4Left: 89,

        left5Width: 16,
        left5Height: 18,
        left5Top: 230,
        left5Left: 89,

        left6Width: 16,
        left6Height: 18,
        left6Top: 256,
        left6Left: 89,

        left7Width: 16,
        left7Height: 18,
        left7Top: 281,
        left7Left: 89,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 89,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 89,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 89,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 89,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 89,

        left13Width: 16,
        left13Height: 18,
        left13Top: 437,
        left13Left: 89,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 89,

        right1Width: 16,
        right1Height: 18,
        right1Top: 128,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 154,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 178,
        right3Left: 403,

        right4Width: 16,
        right4Height: 18,
        right4Top: 204,
        right4Left: 403,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 403,

        right6Width: 16,
        right6Height: 18,
        right6Top: 255,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 281,
        right7Left: 403,

        right8Width: 32,
        right8Height: 18,
        right8Top: 305,
        right8Left: 394,

        right9Width: 28,
        right9Height: 18,
        right9Top: 336,
        right9Left: 396,

        right10Width: 28,
        right10Height: 18,
        right10Top: 361,
        right10Left: 396,

        right11Width: 28,
        right11Height: 18,
        right11Top: 386,
        right11Left: 396,

        right12Width: 28,
        right12Height: 18,
        right12Top: 413,
        right12Left: 396,

        right13Width: 16,
        right13Height: 18,
        right13Top: 437,
        right13Left: 403,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 403,
      },
      ja: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 179,
        headerTop: 46,

        wordwrap: 'normal',
        lineHeight: 2,
        letterspacing: -0.09,
        textResize: 8,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 96,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 96,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 97,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 96,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 97,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 96,

        left9Width: 16,
        left9Height: 18,
        left9Top: 336,
        left9Left: 96,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 96,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 96,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 97,

        left13Width: 16,
        left13Height: 18,
        left13Top: 438,
        left13Left: 97,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 97,

        right1Width: 16,
        right1Height: 18,
        right1Top: 129,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 404,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 403,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 403,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 403,

        right8Width: 25,
        right8Height: 18,
        right8Top: 307,
        right8Left: 398,

        right9Width: 31,
        right9Height: 18,
        right9Top: 341,
        right9Left: 395,

        right10Width: 31,
        right10Height: 18,
        right10Top: 366,
        right10Left: 395,

        right11Width: 31,
        right11Height: 18,
        right11Top: 392,
        right11Left: 395,

        right12Width: 31,
        right12Height: 18,
        right12Top: 419,
        right12Left: 395,

        right13Width: 16,
        right13Height: 18,
        right13Top: 438,
        right13Left: 403,

        right14Width: 16,
        right14Height: 18,
        right14Top: 464,
        right14Left: 403,
      },
      ko: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 235,
        headerTop: 45,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.09,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 113,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 112,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 112,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 112,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 112,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 112,

        left9Width: 16,
        left9Height: 18,
        left9Top: 336,
        left9Left: 112,

        left10Width: 16,
        left10Height: 18,
        left10Top: 361,
        left10Left: 112,

        left11Width: 16,
        left11Height: 18,
        left11Top: 387,
        left11Left: 112,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 113,

        left13Width: 16,
        left13Height: 18,
        left13Top: 438,
        left13Left: 113,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 113,

        right1Width: 16,
        right1Height: 18,
        right1Top: 129,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 402,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 402,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 402,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 402,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 403,

        right8Width: 25,
        right8Height: 18,
        right8Top: 308,
        right8Left: 398,

        right9Width: 31,
        right9Height: 18,
        right9Top: 344,
        right9Left: 395,

        right10Width: 31,
        right10Height: 18,
        right10Top: 369,
        right10Left: 395,

        right11Width: 31,
        right11Height: 18,
        right11Top: 395,
        right11Left: 395,

        right12Width: 31,
        right12Height: 18,
        right12Top: 421,
        right12Left: 395,

        right13Width: 16,
        right13Height: 18,
        right13Top: 438,
        right13Left: 402,

        right14Width: 16,
        right14Height: 18,
        right14Top: 464,
        right14Left: 402,
      },
      lv: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 180,
        headerTop: 45,

        wordwrap: 'break-word',
        lineHeight: 7,
        letterspacing: -0.2,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 179,
        left3Left: 89,

        left4Width: 16,
        left4Height: 18,
        left4Top: 205,
        left4Left: 89,

        left5Width: 16,
        left5Height: 18,
        left5Top: 230,
        left5Left: 89,

        left6Width: 16,
        left6Height: 18,
        left6Top: 255,
        left6Left: 89,

        left7Width: 16,
        left7Height: 18,
        left7Top: 281,
        left7Left: 89,

        left8Width: 16,
        left8Height: 18,
        left8Top: 308,
        left8Left: 89,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 89,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 89,

        left11Width: 16,
        left11Height: 18,
        left11Top: 386,
        left11Left: 89,

        left12Width: 16,
        left12Height: 18,
        left12Top: 411,
        left12Left: 89,

        left13Width: 16,
        left13Height: 18,
        left13Top: 437,
        left13Left: 89,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 89,

        right1Width: 16,
        right1Height: 18,
        right1Top: 128,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 154,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 179,
        right3Left: 403,

        right4Width: 16,
        right4Height: 18,
        right4Top: 204,
        right4Left: 403,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 403,

        right6Width: 16,
        right6Height: 18,
        right6Top: 255,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 282,
        right7Left: 403,

        right8Width: 32,
        right8Height: 18,
        right8Top: 306,
        right8Left: 394,

        right9Width: 28,
        right9Height: 18,
        right9Top: 335,
        right9Left: 396,

        right10Width: 28,
        right10Height: 18,
        right10Top: 360,
        right10Left: 396,

        right11Width: 28,
        right11Height: 18,
        right11Top: 386,
        right11Left: 396,

        right12Width: 28,
        right12Height: 18,
        right12Top: 412,
        right12Left: 396,

        right13Width: 16,
        right13Height: 18,
        right13Top: 437,
        right13Left: 403,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 402,
      },
      lt: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 159,
        headerTop: 46,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.09,
        textResize: 8,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 179,
        left3Left: 89,

        left4Width: 16,
        left4Height: 18,
        left4Top: 205,
        left4Left: 89,

        left5Width: 16,
        left5Height: 18,
        left5Top: 230,
        left5Left: 89,

        left6Width: 16,
        left6Height: 18,
        left6Top: 256,
        left6Left: 89,

        left7Width: 16,
        left7Height: 18,
        left7Top: 280,
        left7Left: 89,

        left8Width: 16,
        left8Height: 18,
        left8Top: 311,
        left8Left: 89,

        left9Width: 16,
        left9Height: 18,
        left9Top: 334,
        left9Left: 89,

        left10Width: 16,
        left10Height: 18,
        left10Top: 361,
        left10Left: 89,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 89,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 89,

        left13Width: 16,
        left13Height: 18,
        left13Top: 438,
        left13Left: 89,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 89,

        right1Width: 16,
        right1Height: 18,
        right1Top: 128,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 154,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 179,
        right3Left: 403,

        right4Width: 16,
        right4Height: 18,
        right4Top: 204,
        right4Left: 403,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 403,

        right6Width: 16,
        right6Height: 18,
        right6Top: 256,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 281,
        right7Left: 403,

        right8Width: 25,
        right8Height: 18,
        right8Top: 307,
        right8Left: 398,

        right9Width: 31,
        right9Height: 18,
        right9Top: 341,
        right9Left: 395,

        right10Width: 31,
        right10Height: 18,
        right10Top: 366,
        right10Left: 395,

        right11Width: 31,
        right11Height: 18,
        right11Top: 393,
        right11Left: 395,

        right12Width: 31,
        right12Height: 18,
        right12Top: 420,
        right12Left: 395,

        right13Width: 16,
        right13Height: 18,
        right13Top: 437,
        right13Left: 403,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 402,
      },
      my: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 163,
        headerTop: 45,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.09,
        textResize: 9,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 89,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 89,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 89,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 89,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 89,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 89,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 89,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 89,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 89,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 89,

        left13Width: 16,
        left13Height: 18,
        left13Top: 438,
        left13Left: 89,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 89,

        right1Width: 16,
        right1Height: 18,
        right1Top: 128,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 403,

        right4Width: 16,
        right4Height: 18,
        right4Top: 205,
        right4Left: 403,

        right5Width: 16,
        right5Height: 18,
        right5Top: 232,
        right5Left: 403,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 403,

        right8Width: 25,
        right8Height: 18,
        right8Top: 307,
        right8Left: 398,

        right9Width: 31,
        right9Height: 18,
        right9Top: 343,
        right9Left: 395,

        right10Width: 31,
        right10Height: 18,
        right10Top: 368,
        right10Left: 395,

        right11Width: 31,
        right11Height: 18,
        right11Top: 394,
        right11Left: 395,

        right12Width: 31,
        right12Height: 18,
        right12Top: 420,
        right12Left: 395,

        right13Width: 16,
        right13Height: 18,
        right13Top: 437,
        right13Left: 403,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 402,
      },
      mt: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 165,
        headerTop: 45,

        wordwrap: 'break-word',
        lineHeight: 7,
        letterspacing: -0.2,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 179,
        left3Left: 89,

        left4Width: 16,
        left4Height: 18,
        left4Top: 205,
        left4Left: 89,

        left5Width: 16,
        left5Height: 18,
        left5Top: 230,
        left5Left: 89,

        left6Width: 16,
        left6Height: 18,
        left6Top: 255,
        left6Left: 89,

        left7Width: 16,
        left7Height: 18,
        left7Top: 281,
        left7Left: 89,

        left8Width: 16,
        left8Height: 18,
        left8Top: 309,
        left8Left: 89,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 89,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 89,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 89,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 89,

        left13Width: 16,
        left13Height: 18,
        left13Top: 437,
        left13Left: 89,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 89,

        right1Width: 16,
        right1Height: 18,
        right1Top: 128,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 154,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 179,
        right3Left: 403,

        right4Width: 16,
        right4Height: 18,
        right4Top: 205,
        right4Left: 403,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 403,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 403,

        right8Width: 32,
        right8Height: 18,
        right8Top: 307,
        right8Left: 394,

        right9Width: 30,
        right9Height: 18,
        right9Top: 335,
        right9Left: 395,

        right10Width: 30,
        right10Height: 18,
        right10Top: 360,
        right10Left: 395,

        right11Width: 30,
        right11Height: 18,
        right11Top: 385,
        right11Left: 395,

        right12Width: 30,
        right12Height: 18,
        right12Top: 413,
        right12Left: 395,

        right13Width: 16,
        right13Height: 18,
        right13Top: 437,
        right13Left: 402,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 402,
      },
      nb: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 155,
        headerTop: 46,

        wordwrap: 'break-word',
        lineHeight: 7,
        letterspacing: -0.2,
        textResize: 8,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 89,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 89,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 89,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 89,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 89,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 89,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 89,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 89,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 89,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 89,

        left13Width: 16,
        left13Height: 18,
        left13Top: 437,
        left13Left: 89,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 89,

        right1Width: 16,
        right1Height: 18,
        right1Top: 130,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 403,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 403,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 403,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 403,

        right8Width: 32,
        right8Height: 18,
        right8Top: 307,
        right8Left: 394,

        right9Width: 30,
        right9Height: 18,
        right9Top: 336,
        right9Left: 395,

        right10Width: 30,
        right10Height: 18,
        right10Top: 361,
        right10Left: 395,

        right11Width: 30,
        right11Height: 18,
        right11Top: 388,
        right11Left: 395,

        right12Width: 30,
        right12Height: 18,
        right12Top: 415,
        right12Left: 395,

        right13Width: 16,
        right13Height: 18,
        right13Top: 438,
        right13Left: 402,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 402,
      },
      pl: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 152,
        headerTop: 45,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.09,
        textResize: 8,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 89,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 89,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 89,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 89,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 89,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 89,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 89,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 89,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 89,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 89,

        left13Width: 16,
        left13Height: 18,
        left13Top: 438,
        left13Left: 89,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 89,

        right1Width: 16,
        right1Height: 18,
        right1Top: 129,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 402,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 403,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 403,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 402,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 403,

        right8Width: 25,
        right8Height: 18,
        right8Top: 307,
        right8Left: 398,

        right9Width: 31,
        right9Height: 18,
        right9Top: 343,
        right9Left: 395,

        right10Width: 31,
        right10Height: 18,
        right10Top: 366,
        right10Left: 395,

        right11Width: 31,
        right11Height: 18,
        right11Top: 393,
        right11Left: 395,

        right12Width: 31,
        right12Height: 18,
        right12Top: 420,
        right12Left: 395,

        right13Width: 16,
        right13Height: 18,
        right13Top: 437,
        right13Left: 402,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 402,
      },
      'pt-BR': {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 152,
        headerTop: 45,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.09,
        textResize: 9,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 89,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 89,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 89,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 89,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 89,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 89,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 89,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 89,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 89,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 89,

        left13Width: 16,
        left13Height: 18,
        left13Top: 438,
        left13Left: 89,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 89,

        right1Width: 16,
        right1Height: 18,
        right1Top: 130,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 403,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 403,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 403,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 402,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 403,

        right8Width: 25,
        right8Height: 18,
        right8Top: 307,
        right8Left: 398,

        right9Width: 31,
        right9Height: 18,
        right9Top: 343,
        right9Left: 395,

        right10Width: 31,
        right10Height: 18,
        right10Top: 368,
        right10Left: 395,

        right11Width: 31,
        right11Height: 18,
        right11Top: 394,
        right11Left: 395,

        right12Width: 31,
        right12Height: 18,
        right12Top: 420,
        right12Left: 395,

        right13Width: 16,
        right13Height: 18,
        right13Top: 437,
        right13Left: 402,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 402,
      },
      ro: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 192,
        headerTop: 45,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.09,
        textResize: 8,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 89,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 89,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 89,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 89,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 89,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 89,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 89,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 89,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 89,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 89,

        left13Width: 16,
        left13Height: 18,
        left13Top: 438,
        left13Left: 89,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 89,

        right1Width: 16,
        right1Height: 18,
        right1Top: 129,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 403,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 402,

        right5Width: 16,
        right5Height: 18,
        right5Top: 232,
        right5Left: 402,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 402,

        right8Width: 25,
        right8Height: 18,
        right8Top: 307,
        right8Left: 398,

        right9Width: 31,
        right9Height: 18,
        right9Top: 343,
        right9Left: 395,

        right10Width: 31,
        right10Height: 18,
        right10Top: 368,
        right10Left: 395,

        right11Width: 31,
        right11Height: 18,
        right11Top: 393.5,
        right11Left: 395,

        right12Width: 31,
        right12Height: 18,
        right12Top: 420,
        right12Left: 395,

        right13Width: 16,
        right13Height: 18,
        right13Top: 438,
        right13Left: 402,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 402,
      },
      ru: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 171.5,
        headerTop: 46,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.09,
        textResize: 8,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 88,

        left4Width: 16,
        left4Height: 18,
        left4Top: 205,
        left4Left: 88,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 88,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 88,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 88,

        left8Width: 16,
        left8Height: 18,
        left8Top: 309,
        left8Left: 88,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 88,

        left10Width: 16,
        left10Height: 18,
        left10Top: 359,
        left10Left: 88,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 88,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 88,

        left13Width: 16,
        left13Height: 18,
        left13Top: 438,
        left13Left: 88,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 88,

        right1Width: 16,
        right1Height: 18,
        right1Top: 129,
        right1Left: 402,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 403,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 402,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 402,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 402,

        right8Width: 25,
        right8Height: 18,
        right8Top: 307,
        right8Left: 398,

        right9Width: 31,
        right9Height: 18,
        right9Top: 343,
        right9Left: 395,

        right10Width: 31,
        right10Height: 18,
        right10Top: 366,
        right10Left: 395,

        right11Width: 31,
        right11Height: 18,
        right11Top: 394,
        right11Left: 396,

        right12Width: 31,
        right12Height: 18,
        right12Top: 421,
        right12Left: 395,

        right13Width: 16,
        right13Height: 18,
        right13Top: 438,
        right13Left: 402,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 402,
      },
      'sr-RS': {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 200,
        headerTop: 46,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.09,
        textResize: 8,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 179,
        left3Left: 88,

        left4Width: 16,
        left4Height: 18,
        left4Top: 205,
        left4Left: 88,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 88,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 88,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 88,

        left8Width: 16,
        left8Height: 18,
        left8Top: 309,
        left8Left: 88,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 88,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 88,

        left11Width: 16,
        left11Height: 18,
        left11Top: 386,
        left11Left: 88,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 88,

        left13Width: 16,
        left13Height: 18,
        left13Top: 437,
        left13Left: 88,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 88,

        right1Width: 16,
        right1Height: 18,
        right1Top: 129,
        right1Left: 402,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 402,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 402,

        right4Width: 16,
        right4Height: 18,
        right4Top: 205,
        right4Left: 402,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 402,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 403,

        right8Width: 25,
        right8Height: 18,
        right8Top: 307,
        right8Left: 398,

        right9Width: 31,
        right9Height: 18,
        right9Top: 343,
        right9Left: 395,

        right10Width: 31,
        right10Height: 18,
        right10Top: 367,
        right10Left: 395,

        right11Width: 31,
        right11Height: 18,
        right11Top: 393,
        right11Left: 395,

        right12Width: 31,
        right12Height: 18,
        right12Top: 420,
        right12Left: 395,

        right13Width: 16,
        right13Height: 18,
        right13Top: 438,
        right13Left: 402,

        right14Width: 16,
        right14Height: 18,
        right14Top: 464,
        right14Left: 402,
      },
      sk: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 159,
        headerTop: 45,

        wordwrap: 'break-word',
        lineHeight: 7,
        letterspacing: -0.2,
        textResize: 8,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 89,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 89,

        left5Width: 16,
        left5Height: 18,
        left5Top: 233,
        left5Left: 89,

        left6Width: 16,
        left6Height: 18,
        left6Top: 259,
        left6Left: 89,

        left7Width: 16,
        left7Height: 18,
        left7Top: 285,
        left7Left: 89,

        left8Width: 16,
        left8Height: 18,
        left8Top: 311,
        left8Left: 89,

        left9Width: 16,
        left9Height: 18,
        left9Top: 336,
        left9Left: 89,

        left10Width: 16,
        left10Height: 18,
        left10Top: 362,
        left10Left: 89,

        left11Width: 16,
        left11Height: 18,
        left11Top: 388,
        left11Left: 89,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 89,

        left13Width: 16,
        left13Height: 18,
        left13Top: 437,
        left13Left: 89,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 89,

        right1Width: 16,
        right1Height: 18,
        right1Top: 130,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 156,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 403,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 403,

        right5Width: 16,
        right5Height: 18,
        right5Top: 233,
        right5Left: 403,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 402,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 403,

        right8Width: 32,
        right8Height: 18,
        right8Top: 307,
        right8Left: 394,

        right9Width: 31,
        right9Height: 18,
        right9Top: 337,
        right9Left: 394,

        right10Width: 31,
        right10Height: 18,
        right10Top: 362,
        right10Left: 394,

        right11Width: 31,
        right11Height: 18,
        right11Top: 388,
        right11Left: 394,

        right12Width: 31,
        right12Height: 18,
        right12Top: 415,
        right12Left: 394,

        right13Width: 16,
        right13Height: 18,
        right13Top: 439,
        right13Left: 402,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 402,
      },
      si: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 153,
        headerTop: 45,

        wordwrap: 'break-word',
        lineHeight: 8,
        letterspacing: -0.2,
        textResize: 9,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 89,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 89,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 89,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 89,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 89,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 89,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 89,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 89,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 89,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 89,

        left13Width: 16,
        left13Height: 18,
        left13Top: 437,
        left13Left: 89,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 89,

        right1Width: 16,
        right1Height: 18,
        right1Top: 130,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 403,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 403,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 403,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 403,

        right8Width: 32,
        right8Height: 18,
        right8Top: 307,
        right8Left: 394,

        right9Width: 28,
        right9Height: 18,
        right9Top: 334,
        right9Left: 396,

        right10Width: 28,
        right10Height: 18,
        right10Top: 360,
        right10Left: 396,

        right11Width: 28,
        right11Height: 18,
        right11Top: 386,
        right11Left: 396,

        right12Width: 28,
        right12Height: 18,
        right12Top: 413,
        right12Left: 396,

        right13Width: 16,
        right13Height: 18,
        right13Top: 438,
        right13Left: 402,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 402,
      },
      es: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 160,
        headerTop: 45,

        wordwrap: 'break-word',
        lineHeight: 7,
        letterspacing: -0.5,
        textResize: 9,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 89,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 89,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 89,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 89,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 89,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 89,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 89,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 89,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 89,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 89,

        left13Width: 16,
        left13Height: 18,
        left13Top: 437,
        left13Left: 89,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 89,

        right1Width: 16,
        right1Height: 18,
        right1Top: 130,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 403,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 403,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 403,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 403,

        right8Width: 32,
        right8Height: 18,
        right8Top: 307,
        right8Left: 394,

        right9Width: 28,
        right9Height: 18,
        right9Top: 336,
        right9Left: 396,

        right10Width: 28,
        right10Height: 18,
        right10Top: 362,
        right10Left: 396,

        right11Width: 28,
        right11Height: 18,
        right11Top: 388,
        right11Left: 396,

        right12Width: 28,
        right12Height: 18,
        right12Top: 415,
        right12Left: 396,

        right13Width: 16,
        right13Height: 18,
        right13Top: 438,
        right13Left: 402,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 402,
      },
      sv: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 164,
        headerTop: 46,

        wordwrap: 'break-word',
        lineHeight: 8,
        letterspacing: -0.2,
        textResize: 9,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 89,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 89,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 89,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 89,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 89,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 89,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 89,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 89,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 89,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 89,

        left13Width: 16,
        left13Height: 18,
        left13Top: 437,
        left13Left: 89,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 89,

        right1Width: 16,
        right1Height: 18,
        right1Top: 130,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 403,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 403,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 403,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 403,

        right8Width: 32,
        right8Height: 18,
        right8Top: 307,
        right8Left: 394,

        right9Width: 28,
        right9Height: 18,
        right9Top: 335,
        right9Left: 396,

        right10Width: 28,
        right10Height: 18,
        right10Top: 360,
        right10Left: 396,

        right11Width: 28,
        right11Height: 18,
        right11Top: 385,
        right11Left: 396,

        right12Width: 28,
        right12Height: 18,
        right12Top: 412,
        right12Left: 396,

        right13Width: 16,
        right13Height: 18,
        right13Top: 438,
        right13Left: 402,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 402,
      },
      'ta-IN': {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 154,
        headerTop: 46,

        wordwrap: 'break-word',
        lineHeight: 7,
        letterspacing: -0.2,
        textResize: 7,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 87,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 87,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 87,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 87,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 88,

        left8Width: 16,
        left8Height: 18,
        left8Top: 310,
        left8Left: 88,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 88,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 88,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 88,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 88,

        left13Width: 16,
        left13Height: 18,
        left13Top: 437,
        left13Left: 88,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 88,

        right1Width: 16,
        right1Height: 18,
        right1Top: 130,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 403,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 403,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 403,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 403,

        right8Width: 32,
        right8Height: 18,
        right8Top: 307,
        right8Left: 394,

        right9Width: 34,
        right9Height: 18,
        right9Top: 336,
        right9Left: 394,

        right10Width: 34,
        right10Height: 18,
        right10Top: 361,
        right10Left: 394,

        right11Width: 34,
        right11Height: 18,
        right11Top: 388,
        right11Left: 394,

        right12Width: 34,
        right12Height: 18,
        right12Top: 414,
        right12Left: 394,

        right13Width: 16,
        right13Height: 18,
        right13Top: 438,
        right13Left: 402,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 402,
      },
      th: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 241.5,
        headerTop: 45,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.09,
        textResize: 11,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 178,
        left3Left: 105,

        left4Width: 16,
        left4Height: 18,
        left4Top: 205,
        left4Left: 105,

        left5Width: 16,
        left5Height: 18,
        left5Top: 226,
        left5Left: 105,

        left6Width: 16,
        left6Height: 18,
        left6Top: 256,
        left6Left: 105,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 105,

        left8Width: 16,
        left8Height: 18,
        left8Top: 303,
        left8Left: 107,

        left9Width: 16,
        left9Height: 18,
        left9Top: 339,
        left9Left: 109,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 105,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 105,

        left12Width: 16,
        left12Height: 18,
        left12Top: 410,
        left12Left: 105,

        left13Width: 16,
        left13Height: 18,
        left13Top: 436,
        left13Left: 105,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 105,

        right1Width: 16,
        right1Height: 18,
        right1Top: 130,
        right1Left: 402,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 402,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 402,

        right4Width: 16,
        right4Height: 18,
        right4Top: 206,
        right4Left: 402,

        right5Width: 16,
        right5Height: 18,
        right5Top: 233,
        right5Left: 402,

        right6Width: 16,
        right6Height: 18,
        right6Top: 259,
        right6Left: 402,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 402,

        right8Width: 25,
        right8Height: 18,
        right8Top: 307,
        right8Left: 398,

        right9Width: 31,
        right9Height: 18,
        right9Top: 343,
        right9Left: 395,

        right10Width: 31,
        right10Height: 18,
        right10Top: 368,
        right10Left: 395,

        right11Width: 31,
        right11Height: 18,
        right11Top: 394,
        right11Left: 395,

        right12Width: 31,
        right12Height: 18,
        right12Top: 421,
        right12Left: 395,

        right13Width: 16,
        right13Height: 18,
        right13Top: 438,
        right13Left: 403,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 403,
      },
      tr: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 154,
        headerTop: 45,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.09,
        textResize: 8,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 178,
        left3Left: 89,

        left4Width: 16,
        left4Height: 18,
        left4Top: 203,
        left4Left: 89,

        left5Width: 16,
        left5Height: 18,
        left5Top: 229,
        left5Left: 89,

        left6Width: 16,
        left6Height: 18,
        left6Top: 255,
        left6Left: 89,

        left7Width: 16,
        left7Height: 18,
        left7Top: 281,
        left7Left: 89,

        left8Width: 16,
        left8Height: 18,
        left8Top: 308,
        left8Left: 89,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 89,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 89,

        left11Width: 16,
        left11Height: 18,
        left11Top: 385,
        left11Left: 89,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 89,

        left13Width: 16,
        left13Height: 18,
        left13Top: 438,
        left13Left: 89,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 89,

        right1Width: 16,
        right1Height: 18,
        right1Top: 127,
        right1Left: 402,

        right2Width: 16,
        right2Height: 18,
        right2Top: 153,
        right2Left: 402,

        right3Width: 16,
        right3Height: 18,
        right3Top: 178,
        right3Left: 402,

        right4Width: 16,
        right4Height: 18,
        right4Top: 203,
        right4Left: 402,

        right5Width: 16,
        right5Height: 18,
        right5Top: 229,
        right5Left: 402,

        right6Width: 16,
        right6Height: 18,
        right6Top: 255,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 281,
        right7Left: 403,

        right8Width: 25,
        right8Height: 18,
        right8Top: 305,
        right8Left: 398,

        right9Width: 31,
        right9Height: 18,
        right9Top: 341,
        right9Left: 395,

        right10Width: 31,
        right10Height: 18,
        right10Top: 366,
        right10Left: 395,

        right11Width: 31,
        right11Height: 18,
        right11Top: 393,
        right11Left: 395,

        right12Width: 31,
        right12Height: 18,
        right12Top: 419,
        right12Left: 395,

        right13Width: 16,
        right13Height: 18,
        right13Top: 437,
        right13Left: 403,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 402,
      },
      ua: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 154,
        headerTop: 46,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.09,
        textResize: 8,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 180,
        left3Left: 87,

        left4Width: 16,
        left4Height: 18,
        left4Top: 205,
        left4Left: 87,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 87,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 87,

        left7Width: 16,
        left7Height: 18,
        left7Top: 283,
        left7Left: 87,

        left8Width: 16,
        left8Height: 18,
        left8Top: 308,
        left8Left: 87,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 88,

        left10Width: 16,
        left10Height: 18,
        left10Top: 360,
        left10Left: 88,

        left11Width: 16,
        left11Height: 18,
        left11Top: 386,
        left11Left: 88,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 88,

        left13Width: 16,
        left13Height: 18,
        left13Top: 436,
        left13Left: 87,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 87,

        right1Width: 16,
        right1Height: 18,
        right1Top: 128,
        right1Left: 402,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 403,

        right3Width: 16,
        right3Height: 18,
        right3Top: 180,
        right3Left: 402,

        right4Width: 16,
        right4Height: 18,
        right4Top: 205,
        right4Left: 402,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 402,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 403,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 403,

        right8Width: 25,
        right8Height: 18,
        right8Top: 307,
        right8Left: 398,

        right9Width: 31,
        right9Height: 18,
        right9Top: 343,
        right9Left: 395,

        right10Width: 31,
        right10Height: 18,
        right10Top: 369,
        right10Left: 395,

        right11Width: 31,
        right11Height: 18,
        right11Top: 393,
        right11Left: 395,

        right12Width: 31,
        right12Height: 18,
        right12Top: 421,
        right12Left: 395,

        right13Width: 16,
        right13Height: 18,
        right13Top: 438,
        right13Left: 403,

        right14Width: 16,
        right14Height: 18,
        right14Top: 464,
        right14Left: 403,
      },
      vi: {
        headerWidth: 32,
        headerHeight: 38,
        headerLeft: 155,
        headerTop: 45,

        wordwrap: 'normal',
        lineHeight: 0,
        letterspacing: -0.09,
        textResize: 9,
        symbolResize: 14,
        right4SymbolResize: 14,
        right7SymbolResize: 14,

        left3Width: 16,
        left3Height: 18,
        left3Top: 181,
        left3Left: 90,

        left4Width: 16,
        left4Height: 18,
        left4Top: 206,
        left4Left: 90,

        left5Width: 16,
        left5Height: 18,
        left5Top: 231,
        left5Left: 90,

        left6Width: 16,
        left6Height: 18,
        left6Top: 257,
        left6Left: 90,

        left7Width: 16,
        left7Height: 18,
        left7Top: 285,
        left7Left: 90,

        left8Width: 16,
        left8Height: 18,
        left8Top: 314,
        left8Left: 93,

        left9Width: 16,
        left9Height: 18,
        left9Top: 335,
        left9Left: 90,

        left10Width: 16,
        left10Height: 18,
        left10Top: 366,
        left10Left: 90,

        left11Width: 16,
        left11Height: 18,
        left11Top: 381,
        left11Left: 94,

        left12Width: 16,
        left12Height: 18,
        left12Top: 412,
        left12Left: 90,

        left13Width: 16,
        left13Height: 18,
        left13Top: 438,
        left13Left: 90,

        left14Width: 16,
        left14Height: 18,
        left14Top: 462,
        left14Left: 90,

        right1Width: 16,
        right1Height: 18,
        right1Top: 128,
        right1Left: 403,

        right2Width: 16,
        right2Height: 18,
        right2Top: 155,
        right2Left: 402,

        right3Width: 16,
        right3Height: 18,
        right3Top: 178,
        right3Left: 402,

        right4Width: 16,
        right4Height: 18,
        right4Top: 205,
        right4Left: 402,

        right5Width: 16,
        right5Height: 18,
        right5Top: 231,
        right5Left: 402,

        right6Width: 16,
        right6Height: 18,
        right6Top: 257,
        right6Left: 402,

        right7Width: 16,
        right7Height: 18,
        right7Top: 283,
        right7Left: 402,

        right8Width: 25,
        right8Height: 18,
        right8Top: 307,
        right8Left: 398,

        right9Width: 31,
        right9Height: 18,
        right9Top: 343,
        right9Left: 395,

        right10Width: 31,
        right10Height: 18,
        right10Top: 368,
        right10Left: 395,

        right11Width: 31,
        right11Height: 18,
        right11Top: 394,
        right11Left: 395,

        right12Width: 31,
        right12Height: 18,
        right12Top: 421,
        right12Left: 395,

        right13Width: 16,
        right13Height: 18,
        right13Top: 437,
        right13Left: 403,

        right14Width: 16,
        right14Height: 18,
        right14Top: 462,
        right14Left: 402,
      },
    };
  }

  public static get SPLITTOPCARDSPOSITION(): any {
    return {
      ar: {
        width: 720,
        height: 529,
        left: 0,
        top: 35,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 309,
        splitCard1Left: 468,
        splitCard2Top: 309,
        splitCard2Left: 534,
        splitCard3Left: 63,
        splitCard4Left: 261,
      },
      he: {
        width: 720,
        height: 529,
        left: 0,
        top: 40,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 315,
        splitCard1Left: 468,
        splitCard2Top: 315,
        splitCard2Left: 534,
        splitCard3Left: 63,
        splitCard4Left: 261,
      },
      bg: {
        width: 720,
        height: 529,
        left: 0,
        top: 56,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 303,
        splitCard1Left: 57,
        splitCard2Top: 303,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      cs: {
        width: 720,
        height: 529,
        left: 0,
        top: 42,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 289,
        splitCard1Left: 57,
        splitCard2Top: 289,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      da: {
        width: 720,
        height: 529,
        left: 0,
        top: 43,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 290,
        splitCard1Left: 57,
        splitCard2Top: 290,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      de: {
        width: 720,
        height: 529,
        left: 0,
        top: 48,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 295,
        splitCard1Left: 57,
        splitCard2Top: 295,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      ee: {
        width: 720,
        height: 529,
        left: 0,
        top: 58,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 305,
        splitCard1Left: 57,
        splitCard2Top: 305,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      en: {
        width: 720,
        height: 529,
        left: 0,
        top: 37,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 284,
        splitCard1Left: 57,
        splitCard2Top: 284,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      es: {
        width: 720,
        height: 529,
        left: 0,
        top: 35,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 282,
        splitCard1Left: 57,
        splitCard2Top: 282,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      fi: {
        width: 720,
        height: 529,
        left: 0,
        top: 35,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 282,
        splitCard1Left: 57,
        splitCard2Top: 282,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      fr: {
        width: 720,
        height: 529,
        left: 0,
        top: 58,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 305,
        splitCard1Left: 57,
        splitCard2Top: 305,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      ge: {
        width: 720,
        height: 529,
        left: 0,
        top: 48,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 295,
        splitCard1Left: 57,
        splitCard2Top: 295,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      gr: {
        width: 720,
        height: 529,
        left: 0,
        top: 53,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 300,
        splitCard1Left: 57,
        splitCard2Top: 300,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      'hi-IN': {
        width: 720,
        height: 529,
        left: 0,
        top: 64,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 311,
        splitCard1Left: 57,
        splitCard2Top: 311,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      hu: {
        width: 720,
        height: 529,
        left: 0,
        top: 56,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 303,
        splitCard1Left: 57,
        splitCard2Top: 303,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      hy: {
        width: 720,
        height: 529,
        left: 0,
        top: 53,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 300,
        splitCard1Left: 57,
        splitCard2Top: 300,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      id: {
        width: 720,
        height: 529,
        left: 0,
        top: 44,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 291,
        splitCard1Left: 57,
        splitCard2Top: 291,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      it: {
        width: 720,
        height: 529,
        left: 0,
        top: 37,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 284,
        splitCard1Left: 57,
        splitCard2Top: 284,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      ja: {
        width: 720,
        height: 529,
        left: 0,
        top: 51,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 298,
        splitCard1Left: 57,
        splitCard2Top: 298,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      kh: {
        width: 720,
        height: 529,
        left: 0,
        top: 48,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 295,
        splitCard1Left: 57,
        splitCard2Top: 295,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      ko: {
        width: 720,
        height: 529,
        left: 0,
        top: 51,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 298,
        splitCard1Left: 57,
        splitCard2Top: 298,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      lt: {
        width: 720,
        height: 529,
        left: 0,
        top: 59,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 306,
        splitCard1Left: 57,
        splitCard2Top: 306,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      lv: {
        width: 720,
        height: 529,
        left: 0,
        top: 51,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 298,
        splitCard1Left: 57,
        splitCard2Top: 298,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      mt: {
        width: 720,
        height: 529,
        left: 0,
        top: 64,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 311,
        splitCard1Left: 57,
        splitCard2Top: 311,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      my: {
        width: 720,
        height: 529,
        left: 0,
        top: 66,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 313,
        splitCard1Left: 57,
        splitCard2Top: 313,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      nb: {
        width: 720,
        height: 529,
        left: 0,
        top: 46,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 293,
        splitCard1Left: 57,
        splitCard2Top: 293,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      nl: {
        width: 720,
        height: 529,
        left: 0,
        top: 40,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 287,
        splitCard1Left: 57,
        splitCard2Top: 287,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      ph: {
        width: 720,
        height: 529,
        left: 0,
        top: 60,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 307,
        splitCard1Left: 57,
        splitCard2Top: 307,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      pl: {
        width: 720,
        height: 529,
        left: 0,
        top: 52,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 299,
        splitCard1Left: 57,
        splitCard2Top: 299,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      'pt-BR': {
        width: 720,
        height: 529,
        left: 0,
        top: 39,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 286,
        splitCard1Left: 57,
        splitCard2Top: 286,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      ro: {
        width: 720,
        height: 529,
        left: 0,
        top: 55,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 302,
        splitCard1Left: 57,
        splitCard2Top: 302,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      ru: {
        width: 720,
        height: 529,
        left: 0,
        top: 47,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 294,
        splitCard1Left: 57,
        splitCard2Top: 294,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      si: {
        width: 720,
        height: 529,
        left: 0,
        top: 60,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 307,
        splitCard1Left: 57,
        splitCard2Top: 307,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      sk: {
        width: 720,
        height: 529,
        left: 0,
        top: 60,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 307,
        splitCard1Left: 57,
        splitCard2Top: 307,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      'sr-RS': {
        width: 720,
        height: 529,
        left: 0,
        top: 60,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 307,
        splitCard1Left: 57,
        splitCard2Top: 307,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      sv: {
        width: 720,
        height: 529,
        left: 0,
        top: 38,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 285,
        splitCard1Left: 57,
        splitCard2Top: 285,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      'ta-IN': {
        width: 720,
        height: 529,
        left: 0,
        top: 74,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 321,
        splitCard1Left: 57,
        splitCard2Top: 321,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      th: {
        width: 720,
        height: 529,
        left: 0,
        top: 55,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 302,
        splitCard1Left: 57,
        splitCard2Top: 302,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      tr: {
        width: 720,
        height: 529,
        left: 0,
        top: 58,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 305,
        splitCard1Left: 57,
        splitCard2Top: 305,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      ua: {
        width: 720,
        height: 529,
        left: 0,
        top: 46,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 293,
        splitCard1Left: 57,
        splitCard2Top: 293,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      vi: {
        width: 720,
        height: 529,
        left: 0,
        top: 43,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 290,
        splitCard1Left: 57,
        splitCard2Top: 290,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      'zh-Hans': {
        width: 720,
        height: 529,
        left: 0,
        top: 49,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 296,
        splitCard1Left: 57,
        splitCard2Top: 296,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
      'zh-Hant': {
        width: 720,
        height: 529,
        left: 0,
        top: 53,
        splitCardWidth: 126,
        splitCardHeight: 164,
        splitCard1Top: 300,
        splitCard1Left: 57,
        splitCard2Top: 300,
        splitCard2Left: 119,
        splitCard3Left: 268,
        splitCard4Left: 468,
      },
    };
  }

  public static get SPLITCARDSPOSITION(): any {
    return {
      ar: {
        cardTop: 313,
        card1Left: 470,
        card2Left: 539,
        card3Left: 259,
        card4Left: 327,
        card5Left: 60,
        card6Left: 134,
        tutorial13Top: 298,
      },
      bg: {
        cardTop: 310,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 287,
      },
      cs: {
        cardTop: 310,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 287,
      },
      da: {
        cardTop: 300,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 287,
      },
      de: {
        cardTop: 300,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 287,
      },
      ee: {
        cardTop: 310,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 290,
      },
      en: {
        cardTop: 310,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 277,
      },
      es: {
        cardTop: 304,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 268,
      },
      fi: {
        cardTop: 306,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 267,
      },
      fr: {
        cardTop: 310,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 292,
      },
      ge: {
        cardTop: 310,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 287,
      },
      gr: {
        cardTop: 305,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 287,
      },
      he: {
        cardTop: 308,
        card1Left: 470,
        card2Left: 539,
        card3Left: 259,
        card4Left: 327,
        card5Left: 60,
        card6Left: 134,
        tutorial13Top: 298,
      },
      'hi-IN': {
        cardTop: 321,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 295,
      },
      hu: {
        cardTop: 310,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 295,
      },
      hy: {
        cardTop: 310,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 287,
      },
      id: {
        cardTop: 314,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 279,
      },
      it: {
        cardTop: 307,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 279,
      },
      ja: {
        cardTop: 306,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 287,
      },
      kh: {
        cardTop: 303,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 287,
      },
      ko: {
        cardTop: 304,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 287,
      },
      lt: {
        cardTop: 316,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 291,
      },
      lv: {
        cardTop: 306,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 287,
      },
      mt: {
        cardTop: 319,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 298,
      },
      my: {
        cardTop: 310,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 298,
      },
      nb: {
        cardTop: 306,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 283,
      },
      nl: {
        cardTop: 303,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 282,
      },
      ph: {
        cardTop: 306,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 290,
      },
      pl: {
        cardTop: 306,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 289,
      },
      'pt-BR': {
        cardTop: 308,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 275,
      },
      ro: {
        cardTop: 306,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 287,
      },
      ru: {
        cardTop: 306,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 287,
      },
      si: {
        cardTop: 314,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 295,
      },
      sk: {
        cardTop: 310,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 295,
      },
      'sr-RS': {
        cardTop: 312,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 295,
      },
      sv: {
        cardTop: 300,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 275,
      },
      'ta-IN': {
        cardTop: 322,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 313,
      },
      th: {
        cardTop: 310,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 288,
      },
      tr: {
        cardTop: 306,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 288,
      },
      ua: {
        cardTop: 319,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 283,
      },
      vi: {
        cardTop: 310,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 283,
      },
      'zh-Hans': {
        cardTop: 310,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 286,
      },
      'zh-Hant': {
        cardTop: 310,
        card1Left: 60,
        card2Left: 134,
        card3Left: 259,
        card4Left: 327,
        card5Left: 470,
        card6Left: 539,
        tutorial13Top: 286,
      },
    };
  }

  public static get ROULETTEPOSITION(): any {
    return {
      ar: {
        bgWidth: 140,
        bgHeight: 181,
        bg17Left: 507,
        bg18Left: 362,
        bg19Left: 219,
        bg20Left: 73,
        bgTop: 281,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 620,
        handContainer18Left: 474,
        handContainer19Left: 331,
        handContainer20Left: 190,
        handContainerTop: 312,
      },
      bg: {
        bgWidth: 140,
        bgHeight: 181,
        bg17Left: 70,
        bg18Left: 219,
        bg19Left: 368,
        bg20Left: 516,
        bgTop: 287,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 177,
        handContainer18Left: 327,
        handContainer19Left: 487,
        handContainer20Left: 634,
        handContainerTop: 312,
      },
      cs: {
        bgWidth: 140,
        bgHeight: 181,
        bg17Left: 68,
        bg18Left: 220,
        bg19Left: 368,
        bg20Left: 519,
        bgTop: 284,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      da: {
        bgWidth: 140,
        bgHeight: 181,
        bg17Left: 69,
        bg18Left: 218,
        bg19Left: 360,
        bg20Left: 511,
        bgTop: 284,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      de: {
        bgWidth: 140,
        bgHeight: 181,
        bg17Left: 71,
        bg18Left: 222,
        bg19Left: 362,
        bg20Left: 511,
        bgTop: 287,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      ee: {
        bgWidth: 140,
        bgHeight: 181,
        bg17Left: 65,
        bg18Left: 215,
        bg19Left: 361,
        bg20Left: 508,
        bgTop: 284,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      en: {
        bgWidth: 140,
        bgHeight: 181,
        bg17Left: 69,
        bg18Left: 220,
        bg19Left: 371,
        bg20Left: 521,
        bgTop: 284,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      es: {
        bgWidth: 140,
        bgHeight: 181,
        bg17Left: 69,
        bg18Left: 217,
        bg19Left: 367,
        bg20Left: 516,
        bgTop: 287,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      fi: {
        bgWidth: 140,
        bgHeight: 181,
        bg17Left: 71,
        bg18Left: 223,
        bg19Left: 374,
        bg20Left: 520,
        bgTop: 287,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      fr: {
        bgWidth: 140,
        bgHeight: 181,
        bg17Left: 71,
        bg18Left: 222,
        bg19Left: 369,
        bg20Left: 519,
        bgTop: 287,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      ge: {
        bgWidth: 140,
        bgHeight: 181,
        bg17Left: 65,
        bg18Left: 213,
        bg19Left: 367,
        bg20Left: 517,
        bgTop: 287,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      gr: {
        bgWidth: 140,
        bgHeight: 193,
        bg17Left: 67,
        bg18Left: 217,
        bg19Left: 370,
        bg20Left: 517,
        bgTop: 274,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      he: {
        bgWidth: 140,
        bgHeight: 181,
        bg17Left: 513,
        bg18Left: 362,
        bg19Left: 220,
        bg20Left: 73,
        bgTop: 287,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 714,
        handContainer18Left: 478,
        handContainer19Left: 331,
        handContainer20Left: 190,
        handContainerTop: 312,
      },
      'hi-IN': {
        bgWidth: 140,
        bgHeight: 181,
        bg17Left: 68,
        bg18Left: 218,
        bg19Left: 372,
        bg20Left: 518,
        bgTop: 287,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      hu: {
        bgWidth: 140,
        bgHeight: 181,
        bg17Left: 66,
        bg18Left: 214,
        bg19Left: 368,
        bg20Left: 510,
        bgTop: 284,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      hy: {
        bgWidth: 148,
        bgHeight: 177,
        bg17Left: 61,
        bg18Left: 209,
        bg19Left: 359,
        bg20Left: 513,
        bgTop: 286,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 177,
        handContainer18Left: 334,
        handContainer19Left: 480,
        handContainer20Left: 639,
        handContainerTop: 312,
      },
      id: {
        bgWidth: 140,
        bgHeight: 181,
        bg17Left: 67,
        bg18Left: 220,
        bg19Left: 371,
        bg20Left: 521,
        bgTop: 284,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      it: {
        bgWidth: 149,
        bgHeight: 171,
        bg17Left: 54,
        bg18Left: 207,
        bg19Left: 363,
        bg20Left: 515,
        bgTop: 290,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 178,
        handContainer18Left: 329,
        handContainer19Left: 489,
        handContainer20Left: 642,
        handContainerTop: 312,
      },
      ja: {
        bgWidth: 140,
        bgHeight: 181,
        bg17Left: 62,
        bg18Left: 223,
        bg19Left: 368,
        bg20Left: 520,
        bgTop: 283,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      kh: {
        bgWidth: 140,
        bgHeight: 181,
        bg17Left: 65,
        bg18Left: 221,
        bg19Left: 363,
        bg20Left: 512,
        bgTop: 287,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      ko: {
        bgWidth: 140,
        bgHeight: 181,
        bg17Left: 65,
        bg18Left: 220,
        bg19Left: 368,
        bg20Left: 521,
        bgTop: 282,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      lt: {
        bgWidth: 140,
        bgHeight: 175,
        bg17Left: 67,
        bg18Left: 215,
        bg19Left: 360,
        bg20Left: 514,
        bgTop: 287,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      lv: {
        bgWidth: 140,
        bgHeight: 174,
        bg17Left: 58,
        bg18Left: 212,
        bg19Left: 361,
        bg20Left: 512,
        bgTop: 287,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      mt: {
        bgWidth: 142,
        bgHeight: 174,
        bg17Left: 68,
        bg18Left: 215,
        bg19Left: 368,
        bg20Left: 511,
        bgTop: 287,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      my: {
        bgWidth: 140,
        bgHeight: 176,
        bg17Left: 62,
        bg18Left: 216,
        bg19Left: 362,
        bg20Left: 507,
        bgTop: 287,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      nb: {
        bgWidth: 149,
        bgHeight: 181,
        bg17Left: 62,
        bg18Left: 216,
        bg19Left: 361,
        bg20Left: 511,
        bgTop: 284,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      nl: {
        bgWidth: 140,
        bgHeight: 173,
        bg17Left: 67,
        bg18Left: 220,
        bg19Left: 363,
        bg20Left: 512,
        bgTop: 287,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      ph: {
        bgWidth: 140,
        bgHeight: 181,
        bg17Left: 62,
        bg18Left: 210,
        bg19Left: 359,
        bg20Left: 500,
        bgTop: 287,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 171,
        handContainer18Left: 326,
        handContainer19Left: 481,
        handContainer20Left: 634,
        handContainerTop: 312,
      },
      pl: {
        bgWidth: 145,
        bgHeight: 175,
        bg17Left: 64,
        bg18Left: 211,
        bg19Left: 365,
        bg20Left: 512,
        bgTop: 287,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      'pt-BR': {
        bgWidth: 140,
        bgHeight: 173,
        bg17Left: 69,
        bg18Left: 220,
        bg19Left: 371,
        bg20Left: 521,
        bgTop: 289,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      ro: {
        bgWidth: 140,
        bgHeight: 178,
        bg17Left: 69,
        bg18Left: 220,
        bg19Left: 368,
        bg20Left: 521,
        bgTop: 284,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      ru: {
        bgWidth: 140,
        bgHeight: 172,
        bg17Left: 69,
        bg18Left: 220,
        bg19Left: 368,
        bg20Left: 521,
        bgTop: 291,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      si: {
        bgWidth: 140,
        bgHeight: 181,
        bg17Left: 64,
        bg18Left: 214,
        bg19Left: 364,
        bg20Left: 512,
        bgTop: 282,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      sk: {
        bgWidth: 140,
        bgHeight: 181,
        bg17Left: 67,
        bg18Left: 220,
        bg19Left: 371,
        bg20Left: 521,
        bgTop: 284,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      'sr-RS': {
        bgWidth: 140,
        bgHeight: 174,
        bg17Left: 69,
        bg18Left: 220,
        bg19Left: 371,
        bg20Left: 521,
        bgTop: 287,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      sv: {
        bgWidth: 140,
        bgHeight: 181,
        bg17Left: 66,
        bg18Left: 220,
        bg19Left: 367,
        bg20Left: 514,
        bgTop: 287,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      'ta-IN': {
        bgWidth: 140,
        bgHeight: 172,
        bg17Left: 60,
        bg18Left: 221,
        bg19Left: 372,
        bg20Left: 518,
        bgTop: 295,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 487,
        handContainer20Left: 637,
        handContainerTop: 319,
      },
      th: {
        bgWidth: 140,
        bgHeight: 167,
        bg17Left: 66,
        bg18Left: 213,
        bg19Left: 358,
        bg20Left: 509,
        bgTop: 296,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      tr: {
        bgWidth: 140,
        bgHeight: 170,
        bg17Left: 61,
        bg18Left: 212,
        bg19Left: 364,
        bg20Left: 514,
        bgTop: 291,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      ua: {
        bgWidth: 140,
        bgHeight: 166,
        bg17Left: 66,
        bg18Left: 217,
        bg19Left: 369,
        bg20Left: 513,
        bgTop: 295,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      vi: {
        bgWidth: 148,
        bgHeight: 181,
        bg17Left: 57,
        bg18Left: 212,
        bg19Left: 365,
        bg20Left: 521,
        bgTop: 281,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 178,
        handContainer18Left: 334,
        handContainer19Left: 492,
        handContainer20Left: 636,
        handContainerTop: 315,
      },
      'zh-Hans': {
        bgWidth: 140,
        bgHeight: 181,
        bg17Left: 69,
        bg18Left: 220,
        bg19Left: 368,
        bg20Left: 521,
        bgTop: 288,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
      'zh-Hant': {
        bgWidth: 140,
        bgHeight: 171,
        bg17Left: 69,
        bg18Left: 220,
        bg19Left: 368,
        bg20Left: 521,
        bgTop: 290,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContainer17Left: 176,
        handContainer18Left: 331,
        handContainer19Left: 478,
        handContainer20Left: 630,
        handContainerTop: 312,
      },
    };
  }

  public static get HANDCARDTUTORIALPOSITION(): any {
    return {
      ar: {
        hand91Left: 239,
        hand91Top: 324,
        hand91_2Left: 548,
        hand91_2Top: 324,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      bg: {
        hand91Left: 273,
        hand91Top: 323,
        hand91_2Left: 544,
        hand91_2Top: 323,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      cs: {
        hand91Left: 273,
        hand91Top: 323,
        hand91_2Left: 544,
        hand91_2Top: 323,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      da: {
        hand91Left: 273,
        hand91Top: 323,
        hand91_2Left: 544,
        hand91_2Top: 323,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      de: {
        hand91Left: 269,
        hand91Top: 313,
        hand91_2Left: 530,
        hand91_2Top: 313,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      ee: {
        hand91Left: 170,
        hand91Top: 304,
        hand91_2Left: 440,
        hand91_2Top: 304,
        handContainerWidth: 64,
        handContainerHeight: 75,
        handContentWidth: 34,
        handContentLeft: 9,
        handContentTop: 27,
        handImageName: 34,
      },
      en: {
        hand91Left: 246,
        hand91Top: 320,
        hand91_2Left: 521,
        hand91_2Top: 320,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      es: {
        hand91Left: 273,
        hand91Top: 323,
        hand91_2Left: 544,
        hand91_2Top: 323,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      fi: {
        hand91Left: 264,
        hand91Top: 345,
        hand91_2Left: 544,
        hand91_2Top: 345,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      fr: {
        hand91Left: 248,
        hand91Top: 334,
        hand91_2Left: 548,
        hand91_2Top: 334,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      ge: {
        hand91Left: 332,
        hand91Top: 316,
        hand91_2Left: 595,
        hand91_2Top: 316,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContentWidth: 34,
        handContentLeft: 18,
        handContentTop: 14,
        handImageName: 55,
      },
      gr: {
        hand91Left: 199,
        hand91Top: 295,
        hand91_2Left: 444,
        hand91_2Top: 295,
        handContainerWidth: 64,
        handContainerHeight: 75,
        handContentWidth: 34,
        handContentLeft: 9,
        handContentTop: 27,
        handImageName: 34,
      },
      he: {
        hand91Left: 290,
        hand91Top: 326,
        hand91_2Left: 605,
        hand91_2Top: 326,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContentWidth: 34,
        handContentLeft: 18,
        handContentTop: 14,
        handImageName: 55,
      },
      'hi-IN': {
        hand91Left: 244,
        hand91Top: 321,
        hand91_2Left: 547,
        hand91_2Top: 335,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContentWidth: 34,
        handContentLeft: 18,
        handContentTop: 14,
        handImageName: 55,
      },
      hu: {
        hand91Left: 290,
        hand91Top: 313,
        hand91_2Left: 532,
        hand91_2Top: 313,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      hy: {
        hand91Left: 280,
        hand91Top: 341,
        hand91_2Left: 520,
        hand91_2Top: 341,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      id: {
        hand91Left: 280,
        hand91Top: 319,
        hand91_2Left: 532,
        hand91_2Top: 319,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      it: {
        hand91Left: 272,
        hand91Top: 337,
        hand91_2Left: 550,
        hand91_2Top: 337,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      ja: {
        hand91Left: 287,
        hand91Top: 336,
        hand91_2Left: 545,
        hand91_2Top: 337,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      kh: {
        hand91Left: 229,
        hand91Top: 319,
        hand91_2Left: 516,
        hand91_2Top: 319,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      ko: {
        hand91Left: 265,
        hand91Top: 319,
        hand91_2Left: 529,
        hand91_2Top: 319,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      lt: {
        hand91Left: 320,
        hand91Top: 311,
        hand91_2Left: 586,
        hand91_2Top: 335,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContentWidth: 34,
        handContentLeft: 18,
        handContentTop: 14,
        handImageName: 55,
      },
      lv: {
        hand91Left: 269,
        hand91Top: 329,
        hand91_2Left: 539,
        hand91_2Top: 329,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      mt: {
        hand91Left: 344,
        hand91Top: 304,
        hand91_2Left: 587,
        hand91_2Top: 303,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContentWidth: 34,
        handContentLeft: 18,
        handContentTop: 14,
        handImageName: 55,
      },
      my: {
        hand91Left: 256,
        hand91Top: 320,
        hand91_2Left: 540,
        hand91_2Top: 338,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      nb: {
        hand91Left: 274,
        hand91Top: 323,
        hand91_2Left: 543,
        hand91_2Top: 344,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      nl: {
        hand91Left: 276,
        hand91Top: 340,
        hand91_2Left: 543,
        hand91_2Top: 340,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      ph: {
        hand91Left: 276,
        hand91Top: 324,
        hand91_2Left: 532,
        hand91_2Top: 341,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      pl: {
        hand91Left: 259,
        hand91Top: 324,
        hand91_2Left: 533,
        hand91_2Top: 324,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      'pt-BR': {
        hand91Left: 278,
        hand91Top: 317,
        hand91_2Left: 534,
        hand91_2Top: 317,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      ro: {
        hand91Left: 267,
        hand91Top: 323,
        hand91_2Left: 533,
        hand91_2Top: 335,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      ru: {
        hand91Left: 279,
        hand91Top: 339,
        hand91_2Left: 552,
        hand91_2Top: 340,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      si: {
        hand91Left: 272,
        hand91Top: 341,
        hand91_2Left: 529,
        hand91_2Top: 341,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      sk: {
        hand91Left: 259,
        hand91Top: 296,
        hand91_2Left: 529,
        hand91_2Top: 296,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      'sr-RS': {
        hand91Left: 277,
        hand91Top: 318,
        hand91_2Left: 530,
        hand91_2Top: 337,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      sv: {
        hand91Left: 267,
        hand91Top: 328,
        hand91_2Left: 525,
        hand91_2Top: 328,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      'ta-IN': {
        hand91Left: 302,
        hand91Top: 302,
        hand91_2Left: 639,
        hand91_2Top: 302,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContentWidth: 34,
        handContentLeft: 18,
        handContentTop: 14,
        handImageName: 55,
      },
      th: {
        hand91Left: 259,
        hand91Top: 324,
        hand91_2Left: 536,
        hand91_2Top: 324,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      tr: {
        hand91Left: 257,
        hand91Top: 341,
        hand91_2Left: 533,
        hand91_2Top: 326,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      ua: {
        hand91Left: 283,
        hand91Top: 307,
        hand91_2Left: 534,
        hand91_2Top: 307,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      vi: {
        hand91Left: 263,
        hand91Top: 322,
        hand91_2Left: 527,
        hand91_2Top: 322,
        handContainerWidth: 54,
        handContainerHeight: 64,
        handContentWidth: 34,
        handContentLeft: 12,
        handContentTop: 26,
        handImageName: 52,
      },
      'zh-Hans': {
        hand91Left: 319,
        hand91Top: 318,
        hand91_2Left: 609,
        hand91_2Top: 318,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContentWidth: 34,
        handContentLeft: 18,
        handContentTop: 14,
        handImageName: 55,
      },
      'zh-Hant': {
        hand91Left: 319,
        hand91Top: 318,
        hand91_2Left: 590,
        hand91_2Top: 318,
        handContainerWidth: 64,
        handContainerHeight: 59,
        handContentWidth: 34,
        handContentLeft: 18,
        handContentTop: 14,
        handImageName: 55,
      },
    };
  }
}
